module.exports = __webpack_public_path__ + "img/pecas.2fbfd088.png";